/** @format */

import React from 'react';
import { Collapse } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { getFacetFields } from '../Config';
import { Facet, WithSearch } from '@elastic/react-search-ui';
import { facetsInfo } from '../Config/data';
import { showElement } from './handlers/showElement.handler';
import { FACET_ELEMENTS } from './constants/facetsInfo.constant';

import './style.scss';

export default function FacetsInfo(props) {
	const { Panel } = Collapse;

	const handleFacetsFilter = () => {
		const facetsFields = getFacetFields(props.params);
		if (props.category && props.params.facets.findIndex((item) => item === 'category') !== -1) {
			facetsFields.splice(props.category, 1);
		}
		return facetsFields;
	};

	return (
		<WithSearch mapContextToProps={({ facets, filters, removeFilter }) => ({ 
			facets,
			filters,
			removeFilter
		})}>
			{({ facets, filters, removeFilter }) => {
				const filteredFacets = handleFacetsFilter()
					.filter((field) => showElement(facets, field, FACET_ELEMENTS.COLLAPSE));

				const allPanelKeys = filteredFacets.map((_, index) => index.toString());

				return (
					<div className="ph-elastic-filter-facet-panel-container">
						<div className="ph-elastic-filter-chips-container">
							<span className="ph-elastic-filter-title">Filtros aplicados:</span>
							<div className="ph-elastic-filter-chips-wrapper">
								{filters && filters.map(filter => {
									const values = filter.values || [filter.value];
									return values.map(value => (
										<span 
											key={`${filter.field}-${value}`}
											className="ph-elastic-filter-chip"
										>
											{value}
											<span 
												className="ph-elastic-filter-chip-close"
												onClick={(e) => {
													e.stopPropagation();
													removeFilter(filter.field, value);
												}}
											>
												×
											</span>
										</span>
									));
								})}
							</div>
							{filters && filters.length > 0 && (
								<button 
									className="ph-elastic-filter-clear-button"
									onClick={() => {
										filters.forEach(filter => {
											if (filter.values) {											
												filter.values.forEach(value => {
													removeFilter(filter.field, value);
												});
											} else {
												removeFilter(filter.field, filter.value);
											}
										});
									}}
								>
									Borrar filtros
								</button>
							)}
						</div>
						<div className="ph-elastic-filter-facet-panel-inner-container">
							<span className="ph-elastic-filter-title">Filtrar:</span>
							<Collapse 
								expandIconPosition={'right'}
								defaultActiveKey={allPanelKeys}
								className='ph-elastic-collapse-item'
								
							>
								{filteredFacets.map((field, index) => (
									<Panel header={`${facetsInfo[field].title}`} key={index} className='ph-elastic-panel-item'>
										<div className={`ph-elastic-filter-facet-element ${showElement(facets, field, FACET_ELEMENTS.SCROLLBAR) ? 'has-scroll' : ''}`}>
											{showElement(facets, field, FACET_ELEMENTS.FILTER) && (
												<SearchOutlined className="ph-elastic-filter-facet-element-icon" />
											)}
											<Facet
												key={field}
												field={field}
												label={`${facetsInfo[field].title}`}
												filterType="any"
												isFilterable={showElement(facets, field, FACET_ELEMENTS.FILTER)}
												show={100}
											/>
										</div>
									</Panel>
								))}
							</Collapse>
						</div>
					</div>
				);
			}}
		</WithSearch>
	);
}
